import { render, staticRenderFns } from "./ClientMedicalExams.vue?vue&type=template&id=56741ad6&scoped=true"
import script from "./ClientMedicalExams.vue?vue&type=script&lang=js"
export * from "./ClientMedicalExams.vue?vue&type=script&lang=js"
import style0 from "./ClientMedicalExams.vue?vue&type=style&index=0&id=56741ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56741ad6",
  null
  
)

export default component.exports